import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {
  BackButton,
  Button,
  Container,
  GovernmentIDInput,
  GovernmentIDInputType,
  Text
} from '../../../components/@FreeModel';
import Header from '../../../components/general/Header/Header';
import {useDispatch, useSelector} from "react-redux";
import {gql, queryApplication, updateApplicationUpdateTaxInfo} from "../../../db/model";
import {selectApplication} from "../../../db/selectors";
import {Mixpanel} from "../../../observability/Mixpanel";

const TaxInfoEIN = (): React.ReactElement => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {applicationID} = useParams()
  const application = useSelector(selectApplication)

  const einLength = 9
  const [tin, setTin] = useState('')

  const isValid = tin.length === einLength;

  useEffect(() => {
    // @ts-ignore
    dispatch(gql({
      query: queryApplication,
      variables: {id: applicationID},
    }))
  }, [dispatch, applicationID]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // @ts-ignore
    dispatch(gql({
      query: updateApplicationUpdateTaxInfo,
      variables: {
        id: applicationID,
        tin,
        tinType: "EIN",
      },
      onSuccess: (_) => {
        Mixpanel.track("contractor-tax-info-added", {
          "invitation": applicationID,
          "tax-info-type": "business",
        })
        navigate(`/contractors/${applicationID}/tax-info/business/review`)
      }
    }))
  };

  return (
    <Container>
      <Header title="Add Tax Info"/>
      <BackButton to={`/contractors/${applicationID}/tax-info/business/address`}/>

      <br/>
      <form onSubmit={handleSubmit}>
        <Text weight="semibold">
          Enter the Employer Identification Number for{' '}
          <strong>{application.businessLegalName}</strong>
          .
        </Text>

        <br/>

        <GovernmentIDInput
          type={GovernmentIDInputType.EIN}
          onChange={value => setTin(value)}
        />

        <br/>
        <br/>
        <br/>

        <Button disabled={!isValid}>Continue</Button>
      </form>
    </Container>
  );
};

export default TaxInfoEIN;
